<style type="text/css">
	.el-table_1_column_7 .cell, .el-table_1_column_10 .cell{
		text-align: center;
	}
	.el-select-dropdown__item span, .el-tag .el-select__tags-text{
		text-transform: capitalize;
	}
	.el-table_1_column_6 .cell{
		padding-left: 15px !important;
	}
	.el-table .warning-row, .el-table table.el-table__body tr.el-table__row.warning-row>td{
	    background: oldlace;
	}
</style>
<style scoped>
	.content-wrapper .content{
		padding-top: 95px;
	}
	.heading-cart{
		position: relative;
		padding-left: 15px;
		padding-right: 15px;
	}
	.box-header .box-title {
		display: inline-block;
		font-size: 15px;
		padding: 10px;
		line-height: 1;
		color: black;
	}
	.heading-cart{
		margin-bottom: 0;
	}
	.box-body{
		padding: 0px 20px 20px;
	}
	.el-button.edit{
		padding: 5px 10px;
	}
	.select-input{
		width: 100%
	}
	.form-label{
		font-weight: bold;
		text-transform: capitalize;
	}
	button[disabled=disabled], button:disabled {
	    background-color: rgba(200,200,200,2.3);
	    border-color: rgba(200,200,200,2.3);
	    cursor: not-allowed;
	}
</style>
<template>
	<div class="content-wrapper">
		<section class="content">
			<div class="box">
				<div class="box-header with-border heading-cart">
					<h3 class="box-title">Admin Reports</h3>
				</div>
				<div class="box-body">
					<el-table v-loading="loading" :data="reportStatus" height="355" style="width: 100%;border-spacing: 0;" id="assoc-table">

						<el-table-column label="Report Date" prop="date" ></el-table-column>
						<el-table-column label="Download Report">
							<template slot-scope="props">
							  <el-button @click="getDownload(props.row.date)" size="mini" round>Download</el-button>
							  <!-- <div @click="getDownload(props.row.date)">
							<download-csv
								:data="json_data"
								v-on:export-finished="exported"
								class="el-button el-button--default el-button--mini is-round">
								<template>Download Data</template>
							</download-csv></div> -->
							</template>
						</el-table-column>
					</el-table>


					<hr>
				</div>
			</div>
		</section>
	</div>
</template>

<script type="text/javascript">
	import axios from 'axios';

	export default {
		data() {
			return{
				biddersList:[],
				reportStatus:[],
				report_name_list:[],
				UploadScreenVisible:false,
				report_date:'',
				bidder_name:'',
				frmdata:new FormData(),
				json_data:[],
		}
		},
		created: function(){
			axios.get(BASE_URL+'reports/v1/report-status/')
			.then(response=>{
				this.reportStatus = response.data.data
				let report_dates_array=[]
				// console.log(this.reportStatus)
				this.reportStatus.map((k)=>{
					report_dates_array.push(k.date)
					// console.log(this.reportStatus)
				})
				let latest_date = this.getLastDateFromReports(report_dates_array)
				console.log(new Date().toJSON().slice(0,10).replace(/-/g,'/'))
				this.report_name_list=this.getDaysArray(new Date(),latest_date.toJSON().slice(0,10).replace(/-/g,'/'))
				console.log(this.report_name_list)
				})
		},
		methods: {
			getDownload:function(date){
				axios.get(BASE_URL +'reports/v1/get-bidder-reports/'+date+'/',{responseType: 'blob'})
				.then(response=>{
					console.log(response)
					const type = response.headers["content-type"]
					console.log(type)
					const url = window.URL.createObjectURL(new Blob([response.data]),{type:type});
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'Bidders Revenue Report - '+date+'.csv');
					document.body.appendChild(link);
					link.click();

				})
			},
			getDaysArray:function(start, end) {
				for(var arr=[],dt=start; dt<=end; dt.setDate(dt.getDate()+1)){
					console.log(start)
					arr.push(new Date(dt));
				}
				return arr;
			},
			getLastDateFromReports:function(arr){
				return new Date(Math.max.apply(null, arr.map(function(e) {
					return new Date(e);
				}))
			)},
			setReport:function(bidder_name,report_date){
				this.UploadScreenVisible = true
				this.report_date = report_date
				this.bidder_name = bidder_name
				// console.log(bidder_name)
			},
			// upload:function(upload){
			// 	// this.incrementNum++
			// 	this.frmdata.append('reportFile',upload.file)
			// },
			// submitUpload:function(){
			// 	this.$refs.upload.submit();
			// 	// this.uploadTrue='start';
			// 	this.frmdata.append('report_date',this.report_date)
			// 	this.frmdata.append('bidder',this.bidder_name)

			// },

	}
	}
</script>


// WEBPACK FOOTER //
// BidderRevenueReports.vue?edf0eb14